import { View } from '../compiler'

import { typoStyles } from '../constants'
import { useTranslationContext } from '../context/general-translations'
import ArrowRightIcon from './heroicons/micro/ArrowRightIcon'
import MarkdownText from './MarkdownText'
import RowListItem from './RowListItem'

const BulletPoints = ({ style, bulletPoints }) => {
  const { tGeneral } = useTranslationContext()

  return (
    <View style={style}>
      <MarkdownText
        style={[typoStyles.T2MediumBlue, { textTransform: 'uppercase' }]}
      >
        {tGeneral('bullet_points_label')}
      </MarkdownText>
      <View style={{ marginTop: 12, flexDirection: 'column', rowGap: 12 }}>
        {bulletPoints.map((point, index) => (
          <RowListItem key={index} Icon={ArrowRightIcon} text={point} />
        ))}
      </View>
    </View>
  )
}

export default BulletPoints
